require("fslightbox");

export const updateVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

const burgerMenu = document.querySelector('.mobile-menu');
const overlay = document.querySelector('.header-menu');

const logo = document.querySelector('.header-logo');
const mobileMenu = document.querySelector('.mobile-menu');

burgerMenu.addEventListener('click', function () {
    this.classList.toggle("close");
    overlay.classList.toggle('overlay');
    logo.classList.toggle('overlay');
});


const points = document.querySelectorAll('.product-img__point-wrapper');

points.forEach(el => {
    el.addEventListener('mouseover',  e => {
        e.currentTarget.classList.add('active');
    });

    el.addEventListener('mouseout',  e => {
        e.currentTarget.classList.remove('active');
    });

})
